var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useState } from 'react';
import { isObject } from 'lodash';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import { prepareHTMLMediaView } from "../../../shared/fileUploadUtils";
import { MediaModal, MediaModalType } from "../../Metadata/components/MediaModal";
import MarkdownMedia from "../../Markdown/components/MarkdownMedia";
import { ImageViewer } from "../../Metadata/components/ImageViewer";









const getValue = (value) =>
isObject(value) && value.data ? value.data : value;

const prepareValue = (
value,
localAttachments) =>
{
  const valueString = getValue(value);
  const values = {
    data: valueString,
    fileURL: valueString,
    type: '',
    originalFile: isObject(value) ? value.originalFile : undefined
  };

  if (/^[a-zA-Z\d_]*$/.test(values.data)) {
    values.type = 'uploadId';
  }

  if (/^https?:\/\//.test(values.data)) {
    values.type = 'webUrl';
  }

  const supportingFile = localAttachments.find(
    (file) => values.data === (file.url || file.fileLocalID || `/api/files/${file.filename}`)
  );

  if (values.type === 'uploadId' && supportingFile) {
    values.originalFile = supportingFile;
    values.fileURL = prepareHTMLMediaView(supportingFile);
  }

  return _objectSpread(_objectSpread({}, values), {}, { supportingFile });
};

const MediaField = (props) => {
  const {
    value,
    onChange,
    type,
    localAttachments = [],
    formModel,
    name: formField,
    multipleEdition
  } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleCloseMediaModal = () => {
    setOpenModal(false);
  };

  const handleImageRemove = () => {
    onChange(null);
  };

  const file = prepareValue(value, localAttachments);
  const constructTimelinksString = (timelinks) => {
    if (!file || !file.data) {
      return null;
    }
    const timelinksObj = timelinks.reduce((current, timelink) => {
      current[`${timelink.timeHours}:${timelink.timeMinutes}:${timelink.timeSeconds}`] =
      timelink.label;
      return current;
    }, {});
    const [, fileLocalID] = file.data.match(/\(?(.*?)(, {|$)/) || ['', file.data];

    return {
      data: `(${fileLocalID}, ${JSON.stringify({ timelinks: timelinksObj })})`,
      originalFile: file.originalFile
    };
  };

  const updateTimeLinks = (timelinks) => {
    onChange(constructTimelinksString(timelinks));
  };

  useEffect(
    () => () => {var _file$supportingFile;
      if (file && (_file$supportingFile = file.supportingFile) !== null && _file$supportingFile !== void 0 && _file$supportingFile.serializedFile && file.fileURL) {
        URL.revokeObjectURL(file.fileURL);
      }
    },
    []
  );

  return (/*#__PURE__*/
    _jsx("div", { className: "search__filter--selected__media" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "search__filter--selected__media-toolbar" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: () => setOpenModal(true), className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, value ? 'Update' : 'Add file')
    ),

    file && file.data && /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleImageRemove, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "unlink" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Unlink")
    )

    ),

    ((_file$supportingFile$) => {
      if (
      file &&
      file.data &&
      file.supportingFile &&
      ((_file$supportingFile$ = file.supportingFile.mimetype) === null || _file$supportingFile$ === void 0 ? void 0 : _file$supportingFile$.search(/image\/*/)) !== -1 ||
      type === MediaModalType.Image)
      {
        return file !== null && file !== void 0 && file.fileURL ? /*#__PURE__*/_jsx(ImageViewer, { src: file.fileURL, alt: "media" }) : null;
      }

      if (file !== null && file !== void 0 && file.fileURL) {
        return (/*#__PURE__*/
          _jsx(MarkdownMedia, {
            config: file === null || file === void 0 ? void 0 : file.fileURL,
            editing: true,
            onTimeLinkAdded: updateTimeLinks,
            type: file === null || file === void 0 ? void 0 : file.type }
          ));

      }
      return null;
    })(), /*#__PURE__*/

    _jsx(MediaModal, {
      isOpen: openModal,
      onClose: handleCloseMediaModal,
      onChange: onChange,
      selectedUrl: file === null || file === void 0 ? void 0 : file.data,
      attachments: localAttachments,
      type: type,
      formModel: formModel,
      formField: formField,
      multipleEdition: multipleEdition }
    )
    ));

};

export default MediaField;